import React from "react";
import CustomCheckbox from "components/customs/checkbox";
import { Check } from "react-feather";
import { getFormattedContactNumber } from "utility/helpers";
import styled from "styled-components";
import { ADD_ACTION } from "constants/actions";
import { CellText } from "assets/js/Styles";

const CheckboxContainer = styled.div`
  width: 100%;
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const newsAddColumns = ({ recipients, setRecipients, action }) => {
  return [
    {
      name: "",
      selector: (row) => row?.id,
      sortable: false,
      width: "60px",
      cell: ({ id }) => {
        return (
          <CheckboxContainer>
            <CustomCheckbox
              onChange={(evt) => {
                const { checked } = evt.target;

                if (checked) {
                  setRecipients({
                    ...recipients,
                    include: [...recipients.include, id],
                  });
                } else {
                  const newItems = recipients.include.filter(
                    (recipient) => recipient !== id
                  );

                  setRecipients({
                    ...recipients,
                    include: newItems,
                  });
                }
              }}
              disabled={action !== ADD_ACTION}
              icon={<Check size={16} />}
              checked={recipients.include.includes(id)}
            />
          </CheckboxContainer>
        );
      },
    },
    {
      name: "Name",
      selector: (row) => row?.name,
      grow: 2,
      sortable: true,
      cell: ({ name }) => <CellText>{name}</CellText>,
    },
    {
      name: "Designation",
      selector: (row) => row?.designation,
      sortable: true,
      cell: ({ designation }) => <CellText>{designation}</CellText>,
    },
    {
      name: "Agency",
      selector: (row) => row?.agency,
      sortable: true,
      cell: ({ agency }) => <CellText>{agency}</CellText>,
    },
    {
      name: "Area",
      selector: (row) => row?.area,
      sortable: true,
      cell: ({ area }) => <CellText>{area}</CellText>,
    },
    {
      name: "Contact Number",
      selector: (row) => row?.contact,
      cell: ({ contact }) => (
        <CellText>{getFormattedContactNumber(contact)}</CellText>
      ),
    },
  ];
};

export default newsAddColumns;
